import React from 'react';
import PropTypes from 'prop-types';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import '../View.css';
import AccountVerificationService from '../../../service/AccountVerificationService';

class AVSWhitelistLookup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      customerId: '',
      status: '',
      isLoading: false,
    };
    this.INPUT_BOX_ID = 'view.customerId.text';
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (event) => {
    this.setState({
      customerId: event.target.value.trim(),
      status: '',
    });
  };

  handleSubmit = () => {
    const { customerId, } = this.state;
    if (customerId === '') {
      return;
    }
    this.setState({
      isLoading: true,
      status: '',
    });

    AccountVerificationService.getActiveWhitelist(customerId)
      .then((result) => {
        let message = (<span>{`Customer ${customerId} is not currently white listed.`}</span>);
        if (result.data.length !== 0) {
          const timestamp = new Date(result.data[0].whiteListExpirationTimestamp * 1000);
          message = (<span>{`Customer ${customerId} is white listed until ${timestamp}`}</span>);
        }
        this.setState({
          status: (
            <Alert dismissible className="mt-2" variant="info">
              {message}
            </Alert>
          ),
        });
      })
      .catch(() => {
        this.setState({
          status: (
            <Alert dismissible className="mt-2" variant="danger">
              <Alert.Heading>Error</Alert.Heading>
              <p>{`Unable to retrieved whitelist records for ${customerId}`}</p>
            </Alert>
          ),
        });
      })
      .finally(() => {
        this.setState({ isLoading: false, });
      });
  };

  render() {
    const vm = this;

    const { onBack, } = this.props;
    const { username, status, isLoading, } = this.state;

    return (
      <div className="content mt-2" style={{ marginTop: '50px', }}>
        <span className="lead">Whitelist Ach Account Lookup</span>
        <br />
        <span>Determine if a customer id is actively whitelisted in Account Verification Service.</span>
        <br />
        <br />
        {status}
        <input
          id={vm.INPUT_BOX_ID}
          className="form-control"
          placeholder="customerId"
          value={username}
          onChange={this.handleChange}
        />
        <br />
        <Button
          variant="primary"
          onClick={this.handleSubmit}
          disabled={isLoading}
        >
          {isLoading ? '...loading' : 'Lookup'}
        </Button>
        <br />
        <br />
        <div className="pull-right">
          <Button variant="link" onClick={onBack}>
            ...back
          </Button>
        </div>
      </div>
    );
  }
}

AVSWhitelistLookup.propTypes = {
  onBack: PropTypes.instanceOf(Function).isRequired,
};

export default AVSWhitelistLookup;
